import type { Sep } from '@/api/queries/user/types/poleEmploi';

export const defaultAvatarUrl = 'img/avatars/defaults/Avatar-unicorn-1.png';

export const customQueryClientKey = 'CustomClient';

export const afCovers = [
  'profile/cover-00.jpg',
  'profile/cover-01.jpg',
  'profile/cover-03.jpg',
  'profile/cover-04.jpg',
  'profile/cover-05.jpg',
  'profile/cover-06.jpg',
  'profile/cover-07.jpg',
  'profile/cover-08.jpg',
  'profile/cover-09.jpg',
  'profile/cover-10.jpg',
  'profile/cover-11.jpg',
  'profile/cover-12.jpg',
  'profile/cover-13.jpg',
  'profile/cover-14.jpg',
  'profile/cover-15.jpg',
];

export const defaultLocale = {
  id: 3,
  iso_code: 'en_US',
  iso_code_639: 'en-US',
  label: 'language_american',
  flag: '',
};

export const seps: { [key in Sep]: string } = {
  P1_autonomy: 'pole_emploi.soft_skills.autonomy',
  P2_decision: 'pole_emploi.soft_skills.individual.decisions',
  P3_curiosity: 'pole_emploi.soft_skills.curiosity',
  P4_power: 'pole_emploi.soft_skills.proactivity',
  P5_persistence: 'pole_emploi.soft_skills.perseverance',
  P6_stepback: 'pole_emploi.soft_skills.individual.objectivity',
  P7_adaptation: 'pole_emploi.soft_skills.adaptability',
  P8_stress: 'pole_emploi.soft_skills.stress',
  P9_reactivity: 'pole_emploi.soft_skills.responsiveness',
  P10_rigor: 'pole_emploi.soft_skills.conscientiousness',
  P11_organization: 'pole_emploi.soft_skills.organization',
  P12_federate: 'pole_emploi.soft_skills.leadership',
  P13_communicate: 'pole_emploi.soft_skills.listening',
  P14_teamwork: 'pole_emploi.soft_skills.teamwork',
  P15_inspire: 'pole_emploi.soft_skills.inspire',
  P16_service: 'pole_emploi.soft_skills.service',
  P17_engagement: 'pole_emploi.soft_skills.engagement',
  P18_creativity: 'pole_emploi.soft_skills.creativity',
};

// @todo: this should be in the config file
export const mixpanelProjectKeys = {
  production: '22b9d6e0493fe586ad81553ebc0ef1fb',
  test: '22eb0f7089b72267f1eda2edc7220493',
};

export const LINKEDIN_HELP = 'https://www.linkedin.com/help/linkedin/answer/a541960';

export const NO_POSITION_JOB_ID = 2051;

// TEMPORARY UGLY FIX
// if some sharepools can't access behavioural styles add an entry in the table with the company uuid and the sharepool uuid(s)
// If all sharepools of a company, specify them all
export const NO_BEHAVIOURAL_STYLES_DATA = [
  {
    company_uuid: '5b02e1711b024c0d973bb33cbcf5b316',
    sharepool_uuids: ['86c3e3bab6494565a347b9d3c08cbb62', '8d677d4f667c4ab6945a89eb89879336'],
  },
];
export const NO_BEHAVIOURAL_STYLES_COMPANY_UUIDS = NO_BEHAVIOURAL_STYLES_DATA.map(
  (item) => item.company_uuid,
);
export const NO_BEHAVIOURAL_STYLES_SHAREPOOL_UUIDS = NO_BEHAVIOURAL_STYLES_DATA.flatMap(
  (item) => item.sharepool_uuids,
);
